import React, { useEffect } from "react"
import PropTypes from "prop-types"
import validator from "email-validator"

function validate(email, callback) {
  callback({ email, isValid: validator.validate(email) })
}

const EmailInput = ({ id, defaultValue, onChange, ...rest }) => {
  useEffect(() => {
    if (defaultValue && onChange) {
      validate(document.getElementById(id).value, onChange)
    }
  }, [id, defaultValue, onChange])

  return (
    <input
      id={id}
      type="email"
      autoComplete="username"
      aria-labelledby={`label_${id}`}
      defaultValue={defaultValue}
      onChange={evt => onChange && validate(evt.target.value, onChange)}
      {...rest}
    />
  )
}

EmailInput.propTypes = {
  id: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
}

export default EmailInput
